import { AppsAndGamesPageVersionItemType } from '../../../domain/page-version';
import { LocalizedString } from 'osn-shared';
import { TrayFormViewModelType } from '../../../create-tray-screen/components/view-model-common/view-model-type';
import { Genre as GenreModel } from '../../../domain/genre';

export enum PageEditTrayLayout {
  Landscape = 'Landscape',
  Portrait = 'Portrait',
  Top10 = 'Top10',
  Expandable = 'Expandable',
  Collection = 'Collection',
  Branded = 'Branded',
  Kids = 'Kids',
  Genre = 'Genre',
  Hero = 'Hero', // AXB-67, AXB-68 // AXB-980
  MarketingCTALeft = 'MarketingCTALeft',
  MarketingCTARight = 'MarketingCTARight',
  MarketingEmailCollectorCentered = 'MarketingEmailCollectorCentered',
  MarketingEmailCollectorLeft = 'MarketingEmailCollectorLeft',
  MarketingEmailCollectorRight = 'MarketingEmailCollectorRight',
  MarketingMultipleContentLandscape = 'MarketingMultipleContentLandscape',
  MarketingMultipleContentPortrait = 'MarketingMultipleContentPortrait',
  MarketingTrendingLeft = 'MarketingTrendingLeft',
  MarketingTrendingRight = 'MarketingTrendingRight',
  StudiosSmall = 'StudiosSmall',
  StudiosMedium = 'StudiosMedium',
  StudiosLarge = 'StudiosLarge',
  MarketingSpotlightTray = 'MarketingSpotlightTray',
  MarketingDeviceModule = 'MarketingDeviceModule',
  MarketingEmailBlocker = 'MarketingEmailBlocker',
  // Introduced in UXB
  LandscapeTwoCardsTray = 'LandscapeTwoCardsTray',
  LandscapeThreeCardsTray = 'LandscapeThreeCardsTray',
  LandscapeFourCardsTray = 'LandscapeFourCardsTray',
  MarketingCTATwoCard = 'MarketingCTATwoCard',
  MarketingCTAThreeCard = 'MarketingCTAThreeCard',
  MarketingCTAFourCard = 'MarketingCTAFourCard',
  CarouselBannerTray = 'CarouselBannerTray',
  BannersOnlyTray = 'BannersOnlyTray',
  SearchTagsTray = 'SearchTagsTray',
  TopTenOnLiveTvTray = 'TopTenOnLiveTvTray',
  TrendingOnAppTray = 'TrendingOnAppTray',
  LandscapePostersTray = 'LandscapePostersTray',
  MarketingBannerTray = 'MarketingBannerTray',
  TopTenOnOSNPlusPosterArtTray = 'TopTenOnOSNPlusPosterArtTray',
  ContinueWatchingTray = 'ContinueWatchingTray',
  MarketingVideoTray = 'MarketingVideoTray',
}

export interface PageEditScreenViewModel {
  pageId: string;
  draftPageVersionId: string;
  publishedPageVersionId: string;
  internalName: string;
  titleEnglish: string;
  titleArabic: string;
  SEOTitle: LocalizedString;
  SEODescription: LocalizedString;
  metaTags: Record<string, string>;
  pageUrl: string;
  trays: PageEditTrayItemViewModel[];
  countryIds?: string[];
  userSegmentIds?: string[];
  platformIds?: string[];
  attachedGenre?: GenreModel;
}

export enum PageEditTrayUserSegment {
  Anonymous = 'anonymous',
  Prospect = 'prospect',
  Normal = 'normal',
  PendingChurn = 'pending-churn',
  Dunning = 'dunning',
  Churned = 'churned',
  All = 'ALL',
}

export interface PageEditTrayItemViewModel {
  id: string;
  name: string;
  trayType: TrayFormViewModelType;
  subType?: AppsAndGamesPageVersionItemType;
  userSegments?: string[];
  countries?: string[];
  scheduledFrom?: string;
  scheduledTo?: string;
  layout: PageEditTrayLayout;
  draggable: boolean;
  visible: boolean;
  order: number;
  allCountriesSelected?: boolean;
  feedName?: string;
  feedId?: string;
  platforms: string[];
  contentGroupId?: string;
  contentGroupName?: string;
  contentGroupPath?: string;
}

export interface PageEditUserSegment {
  id: string;
  label: string;
  originalName: string;
}

export interface CountryViewModel {
  id: string;
  label: string;
  iso2Code: string;
}

export const getAllPlaceholderUserSegment = (): PageEditUserSegment => {
  return {
    id: '',
    label: 'All',
    originalName: '',
  };
};
